module.exports = __webpack_public_path__ + "/images/landing-edu.e0db6d2.webp";